import { useState } from "react";
import { faqItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="常见问题"
          title="看图之前，先弄清楚这几件事"
          desc="关于内容范围、遮挡处理与下载方式的说明。"
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqItems.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left md:py-5"
                    >
                      <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          open
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-600"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {open && (
                      <p className="max-w-3xl pb-5 text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-shield-check-line text-lg" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                内容来源说明
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                本站图片均来自公开讨论中流传的截图整理，仅作信息聚合与对照阅读之用。若涉及个人非必要信息，我们会逐张核验并做遮挡处理。
              </p>
              <a
                href="#top"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                返回顶部
                <i className="ri-arrow-up-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}